import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Header from './Header';
import BasicInfo from './BasicInfo';
import StdSemenInfo from './StdSemenInfo';
import RequestInfo from './RequestInfo';
import ReviewList from './ReviewList';
import SignupOrLogin from './SignupOrLogin';
import MessageForm from './MessageForm';
import Footer from '../../components/Footer';
import { useApi } from '../../hooks/useApi';
import { useAuthUserContext } from '../../providers/AuthUser';
import { useScrollToAnchor } from '../../hooks/useScrollToAnchor';
import { Donor, ApiDonor } from '../../models/Donor';
import { UserType } from '../../types';
import Spinner from '../../components/Spinner';
import { useTitle } from '../../hooks/useTitle';
import { useMetaDescription } from '../../hooks/useMetaDescription';
import { useCanonicalUrl } from '../../hooks/useCanonicalUrl';
import { buildDonorTitle, buildDonorDescription } from './buildDonorMeta';

const DonorIndex = () => {
  const [ apiDonor, setApiDonor ] = useState<ApiDonor>();
  const { user_no } = useParams<{ user_no: string }>();
  const { get, loading } = useApi();
  const { user } = useAuthUserContext();
  const { scrollToAnchor } = useScrollToAnchor();
  const donor = new Donor(apiDonor);

  useTitle(apiDonor ? buildDonorTitle(donor) : 'Ton Bébé | ドナープロフィール');
  useMetaDescription(apiDonor ? buildDonorDescription(donor) : undefined);
  useCanonicalUrl(`/donor/${ user_no }`);

  useEffect(() => {
    setApiDonor(undefined);
    get({
      endpoint: `/api/v1/donors/show_by_no/${ user_no }`,
      skipAuth: true,
      onSuccess: (res) => {
        setApiDonor(res.data);
      },
      onError: (err) => {
        toast.error("ドナー情報の取得に失敗しました。時間をおいてお試しください。");
      },
    });
  }, [ get, user_no ])

  useEffect(() => {
    scrollToAnchor();
  }, [scrollToAnchor]);

  return (
    <div>
      <Header />
      <main className="sub">
        <section className="single_donorinfo">
          <h1 className="sec_title">ドナー詳細情報</h1>
          <BasicInfo donor={ donor } />
          <StdSemenInfo donor={ donor } />
          <RequestInfo donor={ donor } />
          <ReviewList donor={ donor } />
          { !user && <SignupOrLogin donor={ donor } /> }
          { user && user.userType === UserType.Donee && <MessageForm donor={ donor } /> }
        </section>
      </main>
      <Footer />
      { loading && <Spinner size="large" overlay /> }
    </div>
  );
}

export default DonorIndex;
